import React from "react";
import "./menu.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import FoodMenus from "../../Assets/foodmenu.jpeg";
import DrinkMenus from "../../Assets/drinkmenu.jpeg";

function Menu() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="menu-container">
        <img src={FoodMenus} alt="food menu img" className="menu-images" />
        <img src={DrinkMenus} alt="drink menu img" className="menu-images" />
      </div>
    </motion.div>
  );
}

export default Menu;
